// Centralized frontend constants

export const AMOUNT_WARNING_THRESHOLD_CENTS = 300; // €3.00
export const MAX_SPLIT_PARTS = 10;
export const MAX_RECENT_EVENTS_IN_SPLIT_DIALOG = 5;

export const UI_TIMEZONE = "Europe/Berlin";

// TODO: When the PayPal CSV format changes it should be easy to update mappings here.
// For each column name below note: 1) what the CSV column header is, 2) what backend field/table it maps to (if used),
// and 3) any transformations performed (e.g., date/time -> ISO Europe/Berlin, amount string -> cents).
// Example:
// - "Datum" (CSV): maps to paypal_payments.datetime (ISO UTC) via `convertPayPalDatetimeToISO` using Europe/Berlin timezone
// - "Brutto" (CSV): parsed and converted to integer cents and stored in paypal_payments.amount_cents
// - "Absender E-Mail-Adresse" (CSV): matched to users.email or alternativePaypalAccount.email
// Keeping this mapping documented here reduces accidental breakage when PayPal changes export format.
export const PAYPAL_CSV_COLUMNS = {
	DATE: "Datum",
	TIME: "Uhrzeit",
	TIMEZONE: "Zeitzone",
	NAME: "Name",
	TYPE: "Typ",
	STATUS: "Status",
	CURRENCY: "Währung",
	GROSS: "Brutto",
	FEE: "Gebühr",
	NET: "Netto",
	PAYER_EMAIL: "Absender E-Mail-Adresse",
	RECIPIENT_EMAIL: "Empfänger E-Mail-Adresse",
	TRANSACTION_CODE: "Transaktionscode",
	PHONE: "Telefon",
	NOTE: "Hinweis",
};
